<template>
	<div class="adDetection">
		<div class="summary">
			<div class="summary_data">
				<div>
					当前账户检测广告物料信息<span class="def">{{ summary.totalNum }}</span
					>条
				</div>
				<div>
					通过<span class="def success">{{ summary.successNum }}</span
					>条
				</div>
				<div>
					未通过<span class="def fail">{{ summary.failNum }}</span
					>条
				</div>
			</div>
			<div class="but">
				<div class="status">
					<span>自动检测：</span>
					<span :class="detectionConfig.enabled ? 'success' : 'fail'">{{
						detectionConfig.enabled ? '已开启' : '已关闭'
					}}</span>
				</div>
				<el-button type="primary" @click="setConfig">自动检测设置</el-button>
				<el-button type="primary" :loading="detectionLoading" @click="manualDetection">{{
					detectionLoading ? '检测中' : '手动检测'
				}}</el-button>
			</div>
		</div>

		<!-- 筛选 -->
		<filter-panel labelWidth="100px" :data="groups" @search="filterChange"></filter-panel>

		<!-- 列表 -->
		<data-list
			ref="datalist"
			:loadingText="loadingText"
			:table-style="{ name: 'webclient' }"
			:data="data"
			:columns="column"
			:btnList="btnList"
			:loading="loading"
			:selectable="selectable"
			:page="page"
			:page-size="page.pageSize"
			:selection="true"
			@sort-change="sortChange"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@selection-change="selectionChange"
		></data-list>

		<!-- 配置弹窗 -->
		<detectionConfigDialog
			ref="detectionConfigDialogRef"
			dialogWidth="500px"
			title="自动检测设置"
		></detectionConfigDialog>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import detectionConfigDialog from './components/detectionConfigDialog.vue';

import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import googleads from '@/backend/services/googleAds/googleAds.js';

const list = listPageCreate({
	searchConfig: {
		api: api.googleAds.detectionList,
		method: 'POST',
	},
	getQuery(obj, that) {
		let { serviceId } = that.$route.query;
		return _.assign(obj, {
			serviceId,
		});
	},
});

export default {
	name: 'adDetection',
	props: [],
	components: {
		filterPanel,
		detectionConfigDialog,
	},
	mixins: [list],
	data() {
		let that = this;
		return {
			tableRow: [], // 列表选中数据
			loadingText: '加载中', // 文案
			groups: {
				others: [
					{
						tagName: 'sky-select',
						placeholder: '请选择状态',
						label: '状态',
						tagFormatStyle: true,
						prop: 'result',
						value: undefined,
						options: [
							{ label: '通过', value: 1 },
							{ label: '不通过', value: 2 },
						],
					},
					{
						tagName: 'sky-input-prepend',
						placeholder: '输入搜索内容',
						prop: ['name', 'adType'],
						value: ['', 0],
						inputStyle: {
							width: '450px',
						},
						prepend: {
							options: [
								{
									label: '全部',
									value: 0,
								},
								{
									label: '广告系列',
									value: 1,
								},
								{
									label: '广告组',
									value: 2,
								},
							],
							style: {
								width: '180px',
							},
						},
					},
					{
						tagName: 'sky-select',
						placeholder: '请选择属性',
						label: 'type',
						tagFormatStyle: true,
						prop: 'type',
						value: undefined,
						options: [
							{ label: '广告标题', value: 0 },
							{ label: '广告说明语', value: 1 },
							{ label: '附加描述', value: 2 },
						],
					},
				],
			},
			column: [
				{
					label: '内容',
					bind: 'text',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '属性',
					bind: 'type',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						if (val === 0) return '广告标语';
						if (val === 1) return '广告说明语';
						if (val === 2) return '广告描述';
					},
				},
				{
					label: '广告系列',
					bind: 'campaignName',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '广告组',
					bind: 'adGroupName',
					align: 'left',
					type: 'percentage',
					style: {
						textAlign: 'left',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '广告',
					type: 'multipleParames',
					minWidth: 300,
					bind: [
						{
							text: 'finalUrls', // 展示字段
							length: 1, // 展示条数
							tip: '广告 · ', // 前缀
						},
						{
							text: 'titles',
							length: 3,
							separate: ' | ', // 分隔
							tit: 'tit', // 颜色类名
						},
					],
				},
				{
					label: '状态',
					isShowTip: row => {
						let { result } = row;
						return result === 2 || result === 5;
					},
					tipContent: row => {
						let { reason, failReason, result } = row;
						if (result === 2) return reason;
						if (result === 5) return failReason;
					},
					placement: 'top',
					bind: row => {
						let { result } = row;
						if (result === 0) return '未检测';
						if (result === 1) return '检测通过';
						if (result === 2) return '检测不通过';
						if (result === 3) return '已忽略';
						if (result === 4) return '已替换';
						if (result === 5) return '替换失败';
					},
					getClass(row) {
						let { result } = row;
						if (result === 0 || result === 3) return 'deathText';
						if (result === 1 || result === 4) return 'normalText';
						if (result === 2 || result === 5) return 'danger';
					},
				},
				{
					label: '建议',
					width: 220,
					align: 'center',
					bind: 'adviceText',
					type: 'preview',
					iconName: 'copy',
					iconShow: row => {
						let { adviceText } = row;
						if (adviceText) return true;
						return false;
					},
					preview: function (row) {
						let { adviceText } = row;
						that.$copyText(adviceText).then(
							() => {
								that.$message.success('复制成功');
							},
							() => {
								that.$message.warn('复制失败');
							}
						);
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					minWidth: 70,
					bind() {
						let arr = [
							{
								text: '替换',
								trigger: row => {
									let { id } = row;
									that.detectionReplace(id);
								},
								showButton(row) {
									let { result } = row;
									return result === 2 || result === 5;
								},
							},
							{
								text: '忽略',
								trigger: row => {
									let { id } = row;
									that.detectionIgnore(id);
								},
								showButton(row) {
									let { result } = row;
									return result === 2 || result === 5;
								},
							},
							{
								text: '手动检测',
								trigger: row => {
									let { id } = row;
									that.detectionManualSingle(id);
								},
								showButton(row) {
									let { result } = row;
									return result === 3;
								},
							},
						];

						return arr;
					},
				},
			],
			summary: {
				failNum: '-', // 失败条数
				successNum: '-', // 成功条数
				totalNum: '-', // 总条数
			},
			detectionConfig: {}, // 检测配置
			detectionLoading: false, // 手动检测按钮加载状态
			detectionTimer: null, // 轮询检测状态的定时器
		};
	},
	computed: {
		btnList() {
			let that = this;
			return [
				{
					name: '批量替换',
					position: 'left',
					attribute: {
						size: 'small',
						type: 'primary',
						disabled: !this.tableRow.length > 0,
					},
					btnClick() {
						that.detectionReplace();
					},
				},
				{
					name: '批量忽略',
					position: 'left',
					attribute: {
						size: 'small',
						type: 'primary',
						disabled: !this.tableRow.length > 0,
					},
					btnClick() {
						that.detectionIgnore();
					},
				},
			];
		},
	},
	mounted() {
		this.requestData(true);
	},
	methods: {
		requestData(isFirst) {
			this.getDetectionConfig(isFirst);
		},
		// 列表多选
		selectionChange(column) {
			this.tableRow = column;
		},
		// 列表多选筛选
		selectable(row) {
			let { result } = row;
			return result === 2;
		},
		// 广告检测结果汇总
		async getDetectionSummary() {
			let { serviceId } = this.$route.query;
			let res = await googleads.detectionSummary(serviceId);
			this.summary = res.data;
		},
		// 获取广告检测配置
		async getDetectionConfig(isFirst) {
			let { serviceId } = this.$route.query;
			let res = await googleads.getDetectionConfig(serviceId);
			let { status } = res.data;

			if (isFirst) {
				if (status === 1) {
					this.pollDetectionStatus();
				} else {
					this.query();
					this.getDetectionSummary();
				}
			}

			this.detectionConfig = res.data;
			return res.data;
		},
		// 广告检测设置
		async setConfig() {
			let { detectionConfig } = this;
			let { cancel } = await this.$refs.detectionConfigDialogRef.show(detectionConfig);
			if (!cancel) {
				this.getDetectionSummary();
				this.getDetectionConfig();
			}
		},
		// 手动检测
		async manualDetection() {
			let { serviceId } = this.$route.query;
			let res = await googleads.manualDetection(serviceId);
			if (res.data) {
				await this.pollDetectionStatus();
			}
		},
		// 轮询检测状态
		/**
		 * 轮询检测状态
		 */
		async pollDetectionStatus() {
			this.detectionLoading = true;
			this.loading = true;
			this.summary = {
				failNum: '-', // 失败条数
				successNum: '-', // 成功条数
				totalNum: '-', // 总条数
			};
			this.data = [];

			this.detectionTimer = setInterval(async () => {
				try {
					let { serviceId } = this.$route.query;
					if (!serviceId) return clearInterval(this.detectionTimer);

					const config = await this.getDetectionConfig();
					const { status } = config;

					// 定义状态处理映射
					const statusHandlers = {
						2: () => {
							this.$message.success('检测已完成');
							this.detectionLoading = false;
							this.query();
							this.getDetectionSummary();
							clearInterval(this.detectionTimer);
						},
						3: () => {
							this.$message.error('检测失败');
							this.detectionLoading = false;
							this.query();
							this.getDetectionSummary();
							clearInterval(this.detectionTimer);
						},
						default: () => {
							if (status !== 1) {
								this.$message.warning('未知检测状态');
								this.detectionLoading = false;
								this.query();
								this.getDetectionSummary();
								clearInterval(this.detectionTimer);
							}
						},
					};

					// 执行对应的状态处理
					const handler = statusHandlers[status] || statusHandlers.default;
					handler();

					// 如果状态不是1（进行中），则退出循环
					if (status !== 1) {
						clearInterval(this.detectionTimer);
					}
				} catch (error) {
					console.error('轮询出错:', error);
					this.detectionLoading = false;
					clearInterval(this.detectionTimer);
				}
			}, 1500); // 假设原间隔是2秒
		},
		// 广告词替换
		async detectionReplace(id) {
			try {
				let idList;
				let { tableRow } = this;
				if (id) idList = [id];
				else idList = tableRow.map(item => item.id);

				await googleads.detectionReplace({ idList });

				this.$message.success('替换成功');
				this.$refs.datalist.clearSelection();
				this.query();
			} catch (error) {
				this.$message.error('替换失败');
			}
		},
		// 广告词忽略
		async detectionIgnore(id) {
			try {
				let idList;
				let { tableRow } = this;
				if (id) idList = [id];
				else idList = tableRow.map(item => item.id);

				await googleads.detectionIgnore({ idList });

				this.$message.success('忽略成功');
				this.$refs.datalist.clearSelection();
				this.query();
			} catch (error) {
				this.$message.error('忽略失败');
			}
		},
		// 广告语手动检测-单条
		async detectionManualSingle(id) {
			try {
				this.loading = true;
				await googleads.detectionManualSingle(id);
				this.$message.success('检测成功');
				this.query();
			} catch (error) {
				this.$message.error('检测失败');
				this.loading = false;
			}
		},
	},
	beforeDestroy() {
		// 清除定时器
		if (this.detectionTimer) clearInterval(this.detectionTimer);
	},
};
</script>

<style lang="scss" scoped>
.adDetection {
	.summary {
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		background-color: #fff;
		padding: 20px 30px;
		border-bottom: 1px solid #e8e8e8;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.summary_data {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 15px;

			div {
				margin-right: 30px;
			}

			.def {
				font-size: 22px;
				font-weight: bold;
				color: #333;
			}

			.success {
				color: #00d289;
			}

			.fail {
				color: #ff4d4f;
			}
		}
		.but {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 15px;

			.status {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 15px;
				margin-right: 30px;

				.success {
					color: #00d289;
					font-weight: bold;
				}

				.fail {
					color: #ff4d4f;
					font-weight: bold;
				}
			}
		}
	}
}
</style>
